import { authServiceApi } from "../../../app/authServiceApi";
import { API_URL } from "../../../constants/apiUrl";
import { CommonResponse, GetQueryArgsType } from "../../../types";
import {
  GetAllJobAppliedParamsType,
  GetAllJobPostParamsType,
  GetBusinessParamsType,
  GetSingleJobAppliedDataType,
  GetSingleJobPostDataType,
  GetTagList,
  TGetAllJobApplied,
  TGetAllJobPost,
  TGetSkillList,
} from "./job.type";

export const jobApi = authServiceApi.injectEndpoints({
  endpoints: (builder) => ({
    createJobPost: builder.mutation({
      query: (data) => ({
        url: API_URL.createJobPost,
        method: "POST",
        body: data,
      }),
      invalidatesTags: (result) => {
        if (result) return ["GetAllJobPost", "GetSkillList"];
        return [];
      },
    }),
    updateJobPost: builder.mutation({
      query: ({ data, id }) => ({
        url: `${API_URL.updateJobPost}/${id}`,
        method: "PUT",
        body: data,
      }),
      invalidatesTags: (result, _, { id }) => {
        if (result)
          return [
            "GetAllJobPost",
            "GetSkillList",
            {
              type: "GetSingleJobPost",
              id,
            },
          ];

        return [];
      },
    }),
    deleteJobPost: builder.mutation<void, number>({
      query: (id) => ({
        url: `${API_URL.deleteJobPost}/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: (result, _, id) => {
        if (result) return ["GetAllJobPost", { type: "GetSingleJobPost", id }];
        return [];
      },
    }),
    getAllJobPost: builder.query<
      CommonResponse<TGetAllJobPost>,
      GetQueryArgsType<GetAllJobPostParamsType>
    >({
      query: (queryArgs) => ({
        url: API_URL.getAllJobPost,
        ...queryArgs,
      }),
      providesTags: ["GetAllJobPost"],
    }),
    getSkillList: builder.query<
      CommonResponse<TGetSkillList>,
      GetQueryArgsType<GetBusinessParamsType>
    >({
      query: (queryArgs) => ({
        url: API_URL.getSkillList,
        ...queryArgs,
      }),
      providesTags: ["GetSkillList"],
    }),
    getTagList: builder.query<
      CommonResponse<GetTagList>,
      GetQueryArgsType<GetBusinessParamsType>
    >({
      query: (queryArgs) => ({
        url: API_URL.getTagList,
        ...queryArgs,
      }),
      providesTags: ["GetTagList"],
    }),

    getSingleJobPost: builder.query<GetSingleJobPostDataType, number>({
      query: (id) => ({
        url: `${API_URL.getSingleJobPost}/${id}`,
      }),
      providesTags: (_, __, id) => [{ type: "GetSingleJobPost", id }],
    }),

    getJobAppliedList: builder.query<
      CommonResponse<TGetAllJobApplied>,
      GetQueryArgsType<GetAllJobAppliedParamsType>
    >({
      query: (queryArgs) => ({
        url: API_URL.getJobAppliedList,
        ...queryArgs,
      }),
      providesTags: ["GetJobAppliedList"],
    }),

    getSingleJobApplied: builder.query<GetSingleJobAppliedDataType, number>({
      query: (id) => ({
        url: `${API_URL.getSingleJobApplied}/${id}`,
      }),
      providesTags: (_, __, id) => [{ type: "GetSingleJobApplied", id }],
    }),

    hireJobApplication: builder.mutation({
      query: ({ data, id }) => ({
        url: `${API_URL.hireJobApplication}/${id}`,
        method: "PATCH",
        body: data,
      }),
      invalidatesTags: (result, _, { id }) => {
        if (result)
          return [
            "GetAllJobPost",
            "GetJobAppliedList",
            {
              type: "GetSingleJobPost",
              id,
            },
            {
              type: "GetSingleJobApplied",
              id,
            },
          ];

        return [];
      },
    }),
    closeJobPost: builder.mutation({
      query: ({ data, id }) => ({
        url: `${API_URL.closeJoPost}/${id}`,
        method: "PATCH",
        body: data,
      }),
      invalidatesTags: (result, _, { id }) => {
        if (result)
          return [
            "GetAllJobPost",
            "GetJobAppliedList",
            {
              type: "GetSingleJobApplied",
              id,
            },
          ];

        return [];
      },
    }),
    reviewAssignment: builder.mutation({
      query: ({ data, id }) => ({
        url: `${API_URL.reviewAssignment}/${id}`,
        method: "PATCH",
        body: data,
      }),
      invalidatesTags: (result, _, { id }) => {
        if (result)
          return [
            "GetAllJobPost",
            "GetJobAppliedList",
            {
              type: "GetSingleJobPost",
              id,
            },
            {
              type: "GetSingleJobApplied",
              id,
            },
          ];

        return [];
      },
    }),
  }),
});

export const {
  useCreateJobPostMutation,
  useUpdateJobPostMutation,
  useDeleteJobPostMutation,
  useGetAllJobPostQuery,
  useGetSingleJobPostQuery,
  useGetJobAppliedListQuery,
  useGetSingleJobAppliedQuery,
  useHireJobApplicationMutation,
  useGetSkillListQuery,
  useGetTagListQuery,
  useCloseJobPostMutation,
  useReviewAssignmentMutation,
} = jobApi;
